import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { packageAccommodationFormDefault } from "@factory/form/form.default";
import { PackageAccommodationFormRule, PackageAccommodationFormSchema } from "@factory/form/form.rule";
import { useQyCreatePackageAccommodation } from "@factory/query/package-accommodation.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewPackageAccommodation() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreatePackageAccommodation } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New PackageAccommodation is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addPackageAccommodation, isLoading: isCreating } =
    useQyCreatePackageAccommodation(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<PackageAccommodationFormSchema>({
    defaultValues: packageAccommodationFormDefault,
    resolver: zodResolver(PackageAccommodationFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: PackageAccommodationFormSchema) => {
    const formData = mapCreatePackageAccommodation(form);
    addPackageAccommodation(formData);
  };
  const handleValidateError = (err: FieldErrors<PackageAccommodationFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
